<template>
  <div class="pager-wrap">
    <transition-group
      name="list"
      tag="ul"
      class="pager"
      appear
    >
      <li
        v-for="page in pages"
        :key="page.page"
        class="pager__item"
        :class="{
          'pager__item--arrow': page.type == 'nav',
          'pager__item--current': page.current,
          'pager__item--sep': page.type == 'sep'
        }"
      >
        <a
          v-if="page.type != 'sep'"
          class="pager__page"
          @click.prevent="setPage(page)"
        >{{ page.label }}</a>
        <a
          v-else
          class="pager__sep"
          @click.prevent
        >...</a>
      </li>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    args: Object
  },
  data() {
    return {
      limit: 2
    };
  },
  computed: {
    pages() {
      let pages = [];
      // Prev button.
      if (this.args.paged > 1) {
        pages.push({
          type: "nav",
          page: "prev",
          label: "<",
          current: false
        });
      }
      // First & sep.
      if (this.args.paged > 4) {
        pages.push({
          type: "page",
          page: 1,
          label: 1,
          current: false
        });
        pages.push({
          type: "sep",
          page: "sep-first",
          label: "sep-first",
          current: false
        });
      }
      // Prev pages.
      let previousPages = [];
      let prevPage = Number(this.args.paged) - 1;
      let prevLimit = prevPage - this.limit;
      while (prevPage > prevLimit) {
        if (0 < prevPage) {
          previousPages.push({
            type: "page",
            page: prevPage,
            label: prevPage,
            current: false
          });
        }
        prevPage--;
      }

      pages = [...pages, ...previousPages.reverse()];
      // Current.
      pages.push({
        type: "page",
        page: this.args.paged,
        label: this.args.paged,
        current: true
      });
      // Next pages.
      let nextPages = [];
      let nextPage = Number(this.args.paged) + 1;
      let nextLimit = nextPage + this.limit;
      while (nextPage < nextLimit) {
        if (nextPage <= this.args.maxPage) {
          nextPages.push({
            type: "page",
            page: nextPage,
            label: nextPage,
            current: false
          });
        }
        nextPage++;
      }
      pages = [...pages, ...nextPages];
      // Sep & Last
      if (this.args.paged < this.args.maxPage - 3) {
        pages.push({
          type: "sep",
          page: "sep-last",
          label: "sep-last",
          current: false
        });
        pages.push({
          type: "page",
          page: this.args.maxPage,
          label: this.args.maxPage,
          current: false
        });
      }
      // Next button.
      if (this.args.paged < this.args.maxPage) {
        pages.push({
          type: "nav",
          page: "next",
          label: ">",
          current: false
        });
      }
      return pages;
    }
  },
  watch: {
    args: {
      deep: true,
      handler(args) {
        this.$router
          .push({
            name: "Catalog",
            query: {
              ...this.$route.query,
              page: args.paged
            }
          })
          .catch(err => {});
      }
    }
  },
  methods: {
    setPage(page) {
      if (page != this.args.paged) {
        if (page.type == "sep") {
          return;
        }
        if (page.type == "nav") {
          if (page.page == "next" && this.args.paged < this.args.maxPage) {
            this.args.paged++;
          } else if (1 < this.args.paged) {
            this.args.paged--;
          }
        } else {
          this.args.paged = page.page;
        }
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $('.products-in-cat').offset().top - 100,
          },
          200
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pager__item {
  display: inline-block;
  transition: all 0.5s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.list-leave-active {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/Pager.vue